module.exports = __webpack_public_path__ + "static/media/Measure Ruler Corner.07bba5a2.svg";